import { authHeader, handleResponse } from 'helpers';
import { apiConstants } from '../constants';
import { queryFilters, queryWhere } from '../helpers/util';
import { userStorage } from 'helpers/user-storage';

export const invnumberService = {
  get,
  getAll,
  getCities,
  getJurisdictions,
  add,
  addBulk,
  downloadTemplate
};

function downloadTemplate() {
  const filename = 'invnumbers.xlsx';
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  var url = apiConstants.getTemplateExcel.replace(':template', filename)
  return fetch(url, requestOptions)
    .then(response => {
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
      });
    });
}

function getJurisdictions() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  var url = apiConstants.getInvNumberJurisdictions;
  return fetch(`${url}`, requestOptions)
    .then(handleResponse);
}

function getCities() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  var url = apiConstants.getInvNumberCities;
  return fetch(`${url}`, requestOptions)
    .then(handleResponse);
}

function get(invnumber_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  if (invnumber_id) {
    var url = apiConstants.getInvNumber.replace(':invnumber_id', invnumber_id)
    return fetch(url, requestOptions)
      .then(handleResponse);
  } else return undefined;

}

function getAll(limit, page, filters = undefined) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  var url = apiConstants.getInvNumbers;
  var queryfilters = queryFilters(limit, page);
  if (filters) queryfilters = queryfilters.concat('', queryWhere(filters));
  return fetch(`${url}${queryfilters}`, requestOptions)
    .then(handleResponse);
}


function add(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(data)
  };
  var url = apiConstants.addInvNumber;
  return fetch(url, requestOptions)
    .then(handleResponse);
}
function addBulk(file) {
  let headers = '';
  let token = userStorage.getToken();
  if (token) { headers = { Authorization: token }; }

  const requestOptions = {
    method: 'POST',
    headers: headers,
    // headers: authHeader(),
    body: (file)
  };

  var url = apiConstants.addBulkInvNumber;
  return fetch(`${url}`, requestOptions)
    .then(handleResponse);
}
